import{useReducer as r}from"react";const t=()=>{const[,t]=r((r=>r+1),0);return t};export{t as useForceUpdate};
//# sourceMappingURL=useForceUpdate.js.map
